import { CSSProperties } from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { IChecklistTask } from '@features/Checklist/model/types';

export const useChecklistItemDragging = ({
    itemData,
    canEdit,
}: {
    itemData: IChecklistTask;
    canEdit: boolean;
}) => {
    const {
        attributes,
        listeners,
        setActivatorNodeRef,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({
        id: itemData.clientId,
        disabled: !canEdit,
    });
    const style: CSSProperties = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0 : 1,
        pointerEvents: isDragging ? 'none' : undefined,
    };

    return {
        style,
        attributes,
        listeners,
        isDragging,
        setActivatorNodeRef,
        setNodeRef,
    };
};
